import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const UsersLayout = lazy(() => import('@/pages/users/layout'));
const UserTabsLayout = lazy(() => import('@/pages/users/[userId]/(tabs)/layout'));

// Lazy load user pages
const UsersPage = lazy(() => import('@/pages/users'));
const CreateUserPage = lazy(() => import('@/pages/users/create'));
const UsersHistoryPage = lazy(() => import('@/pages/users/history'));
const UserDetailsPage = lazy(() => import('@/pages/users/[userId]/(tabs)/details'));
const UpdateUserPage = lazy(() => import('@/pages/users/[userId]/(tabs)/update'));
const UserPermissionsPage = lazy(() => import('@/pages/users/[userId]/(tabs)/permissions'));
const UserHistoryPage = lazy(() => import('@/pages/users/[userId]/(tabs)/history'));

/**
 * User routes
 * Handles user management with tab-based navigation for user details
 */
export const userRoutes: RouteConfig = {
  path: '/users',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: UsersLayout,
      children: [
        {
          path: '',
          element: UsersPage,
        },
        {
          path: '/create',
          element: CreateUserPage,
        },
        {
          path: '/history',
          element: UsersHistoryPage,
        },
      ],
    },
    {
      path: '/:userId',
      layout: UserTabsLayout,
      children: [
        {
          path: '/details',
          element: UserDetailsPage,
        },
        {
          path: '/update',
          element: UpdateUserPage,
        },
        {
          path: '/permissions',
          element: UserPermissionsPage,
        },
        {
          path: '/history',
          element: UserHistoryPage,
        },
      ],
    },
  ],
};
